const prefix = 'SEARCHLAYOUT_';

export const SET_MODULES = `${prefix}SET_MODULES`;


// WEBPACK FOOTER //
// ./src/views/Setup/SearchLayout/flow/actionType.js